// extracted by css-extract-rspack-plugin
export default {"codeblock":"codeblock-Ja0ilr","header":"header-VpoN0L","copyButton":"copyButton-uVk0FZ"};